export enum ImageEvent {
  Error = "Error",
  LoadingStateChange = "LoadingStateChange",
}

export interface ImageEventPayloadMap {
  [ImageEvent.Error]: Error;
  [ImageEvent.LoadingStateChange]: { isLoading: boolean };
}
